import React, { useCallback, useEffect } from 'react';
import { reduxForm, Field } from 'redux-form';

import { SelectInput } from '../SelectInput';

const DeviceExclusionEditForm = ({ thresholdDeviceDataTypeExclusions, deviceDataTypes, onSelection, initialize }) => {
  const dataTypeOptions = deviceDataTypes.sort((a,b) => (a.last_nom > b.last_nom) ? 1 : ((b.last_nom > a.last_nom) ? -1 : 0)).map(ddt => ({ label: ddt.name, value: ddt.id, deviceDataType: ddt } ));

  useEffect(() => {
    initialize({
      thresholdDeviceDataTypeExclusions: thresholdDeviceDataTypeExclusions.map((ddt) => ({ label: ddt.name, value: ddt.id, deviceDataType: ddt })),
    });
  }, [thresholdDeviceDataTypeExclusions]);

  const convertSelection = useCallback((values) => {
    let convertedValues = [];
    Object.keys(values).map(function(key) {
      if(key !== 'preventDefault') convertedValues.push(values[key].deviceDataType);
    });
    onSelection(convertedValues);
  }, []);

  return (
    <form className="tag-edit-form">
      <Field name="thresholdDeviceDataTypeExclusions" options={dataTypeOptions} component={SelectInput} isMulti onChange={convertSelection} />
    </form>
  );
};

export default reduxForm({ form: "DeviceExclusionEditForm" })(DeviceExclusionEditForm);
